import React from "react";
import ReactDOM from "react-dom";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import GlobalStyle from "~/shared/theme/GlobalStyle";

import App from "./app";

const client = new ApolloClient({
  uri:
    "https://api-eu-central-1.graphcms.com/v2/ckscc3c4b37i701xqelo2dheq/master",
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <GlobalStyle />

      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
